import React, { useState, useEffect, useRef,useMemo } from 'react'
import Select from 'react-select'
import { CSVLink } from "react-csv";
import { SlButton, SlDrawer, SlTooltip, SlOption, SlSelect, SlInput, SlTab, SlTabGroup, SlTabPanel, SlIcon, SlDivider } from '@shoelace-style/shoelace/dist/react';
import { BrandsTypes, formatAmount, roles,languageOptions, toLakhs } from "../../utils/constants";
import SakshiImage from "../../assets/images/sakshi-logo.png";
import EenaduImage from "../../assets/images/eenadu-logo.png";
import MikeImage from "../../assets/images/mike.png";
import LocationImage from "../../assets/images/location.png"
import Datepicker from "react-tailwindcss-datepicker";
import api from "../../services/api";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router';
import { adTypes } from '../../utils/constants';
import NoDataFound from "../../shared/NoDataFound";
import Multiselect from "multiselect-react-dropdown";
import Button from 'react-bootstrap/Button';
import NoImage from "../../assets/images/NoImage.png";
import LocationSVG from "../../assets/images/location.svg";
import { formatDate } from "../../utils/dateFormat";
import { Modal } from "react-bootstrap";
import DinathanthiImage from '../../assets/images/dinathanthi-logo.png'
import { ScrollContainer } from 'react-indiana-drag-scroll';
import TableSkelton from '../../shared/TableSkelton';
import { Toast } from "../../shared/Toast";
import ReportBirdview from '../SalesPanel/ReportBirdview';
import PrintDataSummary from './PrintDataSummary';

function CompetitorReports() {
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Subtract 7 days

    const formatFullDate = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    function formatSpentValue(value) {
        if (value < 1000) {
            return `${value}`;
        } else if (value >= 1000 && value < 100000) {
            const kValue = (value / 1000).toFixed(2);
            return `${kValue}K`;
        } else if (value >= 100000 && value < 10000000) {
            const lValue = (value / 100000).toFixed(2);
            return `${lValue}L`;
        } else if (value >= 10000000) {
            const crValue = (value / 10000000).toFixed(2);
            return `${crValue}Cr`;
        } else {
            return 0;
        }
    }

    function calculatePercentage(value, total) {
        if (total === 0) {
            return 0;
        }

        const percentage = (value / total) * 100;
        return parseFloat(percentage.toFixed(2));
    }

    const formattedStartDate = formatFullDate(sevenDaysAgo);
    const formattedEndDate = formatFullDate(today);

    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1); // Get the first day of the current month
    firstDayOfMonth.setHours(0, 0, 0, 0); // Set the time to midnight (00:00:00)
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("revenue_estimates")
    const [dateRange, setDateRange] = useState({ startDate: formattedStartDate, endDate: formattedEndDate });
    const [regionDateRange, setRegionDateRange] = useState({ startDate: formattedStartDate, endDate: formattedEndDate });
    const [source, setSource] = useState("Media");
    const [loader, setLoader] = useState(false);
    const [revenueEstimates, setRevenueEstimates] = useState([]);
    const [thisMonthReports, setThisMonthReports] = useState([]);
    const [totalThisMonthRevenue, setTotalThisMonthRevenue] = useState(0);
    const [totalThisMonthBrands, setTotalThisMonthBrands] = useState(0);
    const [totalThisMonthCampaigns, setTotalThisMonthCampaigns] = useState(0);
    const [brandDate, setBrandDate] = useState("");
    const [brandsList, setBrandsList] = useState([]);
    const [campaignDate, setCampaignDate] = useState("");
    const [campaignList, setCampaignList] = useState([]);
    const [open, setOpen] = useState(false);
    const [tillToday, setTillToday] = useState({ Today: null, FirstDayOfMonth: null });
    const [regionReports, setRegionReports] = useState([])
    const [selectedQuery, setSelectedQuery] = useState("all_brands")
    const [queryLang, setQueryLang] = useState(["1"]);
    const [queryAdType, setQueryAdType] = useState("All");
    const [queryLocation, setQueryLocation] = useState([]);
    const [regionLocations, setRegionLocations] = useState([]);
    const [queryBrandType, setQueryBrandType] = useState("All");
    const [regionQueryBrandType, setRegionQueryBrandType] = useState([]);
    const [queryMedia, setQueryMedia] = useState([]);
    const [queryCategory, setQueryCategory] = useState([]);
    const [queryDateRange, setQueryDateRange] = useState({ startDate: formattedStartDate, endDate: formattedEndDate });
    const [queryData, setQueryData] = useState([]);
    const [allBrandTotal, setAllBrandTotal] = useState(0);
    const [languages, setLanguages] = useState([]);
    const [categories, setCategories] = useState([]);
    const [locations, setLocations] = useState([]);
    const [revenueStats, setRevenueStats] = useState({});
    const [newspapers, setNewspapers] = useState([]);
    const [selectedSources, setSelectedSources] = useState(["Eenadu"]);
    const [userType, setUserType] = useState("");
    const [name, setName] = useState("");
    const [campaigns, setCampaigns] = useState([])
    const [view, setView] = useState(false);
    const [see, setSee] = useState(false);
    const [imgSrc, setImgSrc] = useState("")
    const [newspaperData, setNewsPaperData] = useState([]);
    const [summary, setSummary] = useState([])
    const [regionSummary, setRegionSummary] = useState([])
    const [downloadQueryData, setDownloadQueryData] = useState([])
    const [downloadLoader, setDownloadLoader] = useState(false);
    const [downloadloadernew,setDownloadLoadernew]=useState(false);
    const [checked, setChecked] = useState(false);
    const [way2Brandcount,setway2Brandcount]=useState(0);
    const [topData,setTopData]=useState([]);
    const [wayBrandTotal,setwayBrandTotal]=useState([]);
    const [compcount,setcompcount]=useState(0);
    const [newspaperLocations, setNewspaperLocations] = useState([])
    const [newspaperLocationsObject, setNewspaperLocationsObject] = useState([])
    const [downloadQueryoldData,setDownloadQueryoldData]=useState([]);
    const [downloadW2NData, setDownloadW2NData] = useState([]);
    const [downloadW2NLoader, setDownloadW2NLoader] = useState(false);
    const csvLinkRefW2N = useRef();
    const [selectedDistricts, setSelectedDistricts] = useState();
    const [district,setdistricts] = useState([])
    const [summaryData,setSummaryData] = useState([])
    const [showReport, setShowReport] = useState(false)
    const [reportId, setReportId] = useState(0)
    const [imageUrl, setImageUrl] = useState()
    const [summaryPayload,setSummaryPayload] = useState({})

    const getDistricts = async()=>{
        const lang_ids = languageOptions
            .filter(lang => lang.label === "Telugu")
            .map(lang => lang.value);
        try {
            const res = await api({ url: `/birdview/getDistrictsByLang`, method: "POST", data: {lang_ids} });
            if (res.code === 200) setdistricts(res.data);
          } catch (error) {}
    }
    const locationObject = useMemo(() => {
        const obj = {};
        newspaperLocationsObject.forEach((location) => {
            obj[location.value] = location.label;
        });
        return obj;})
    const getLocations = (locations) => {
    
        if (!locations) return '';
        // Wrap in array if it's not already one
        if (!Array.isArray(locations)) {
            locations = [locations];
        }
    
        const location_names = [];
    
        for (const location of locations) {
            const name = locationObject[+location]; // + converts to number
            if (name) location_names.push(name);
        }
    
        return location_names.length > 0 ? location_names.join(', ') : '';
    };
    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
    };

    const handleSelectedQUery = (query) => {
        setSelectedQuery(query);
        setChecked(false);
    };

    const handleQueryLang = (lang) => {
        setQueryLang(lang);
    }

    const handleDateRange = (selectedDate) => {
        if (selectedDate) {
            if (selectedDate.startDate && selectedDate.endDate) {
                setDateRange(selectedDate);
            } else {
                setDateRange({ startDate: null, endDate: null });
            }
        } else {
            setDateRange({ startDate: null, endDate: null });
        }
    }

    const handleRegionDateRange = (selectedDate) => {
        if (selectedDate) {
            if (selectedDate.startDate && selectedDate.endDate) {
                setRegionDateRange(selectedDate);
            } else {
                setRegionDateRange({ startDate: null, endDate: null });
            }
        } else {
            setRegionDateRange({ startDate: null, endDate: null });
        }
    }

    const handleQueryDateRange = (selectedDate) => {
        if (selectedDate) {
            if (selectedDate.startDate && selectedDate.endDate) {
                setQueryDateRange(selectedDate);
            } else {
                setQueryDateRange({ startDate: null, endDate: null });
            }
        } else {
            setQueryDateRange({ startDate: null, endDate: null });
        }
    }

    const loadRevenueStats = async (userType) => {
        try {
            if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) {
                setLoader(true);
                let res = await api({
                    url: `/competitor_reports/revenueStats`,
                    method: "POST",
                    responseType: "json",
                    data: { userType }
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    setRevenueStats(res?.data ? res?.data : {});
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const fetchNewsPapers = async () => {
        try {
            let res = await api({
                url: "/market/newspapers",
                method: "POST",
                responseType: "json",
                data: {},
            });
            if (res.code === 200) {
                 setNewsPaperData([...(res.data.filter(item => item.name !== 'Way2news'))]);
                //setNewsPaperData([...res.data]);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getColors = (brand) => {
        const brandLookup = newspaperData.filter((np) => np.name === brand);
        return {
            backgroundColor: brandLookup[0]?.background_color,
            color: brandLookup[0]?.color,
        };
    };

    const loadNewspapers = async () => {
        if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && (activeTab === "region" || activeTab === "query")) {
            setLoader(true);
            const response = await api({
                url: `/birdview/newspapers`,
                method: "POST",
                responseType: "json",
            });
            if (response?.code === 200) {
                setNewspapers(response?.data?.result);
                setLoader(false);
            } else {
                toast.error(response?.data?.message)
            }
        }
    };

    const loadLanguages = async () => {
        try {
            if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && activeTab === "query") {
                setLoader(true);
                let res = await api({
                    url: `/competitor_reports/getLanguages`,
                    method: "POST",
                    responseType: "json",
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    setLanguages(res?.data?.result?.length ? res?.data?.result : []);
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const loadCategories = async () => {
        try {
            if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && activeTab === "query") {
                setLoader(true);
                let res = await api({
                    url: `/competitor_reports/getCategories`,
                    method: "POST",
                    responseType: "json",
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    setCategories(res?.data?.result?.length ? res?.data?.result : []);
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const loadLocations = async () => {
        try {
            if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && (activeTab === "query" || activeTab === 'region')) {
                setLoader(true);
                let res = await api({
                    url: `/competitor_reports/getLocations`,
                    method: "POST",
                    responseType: "json",
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    // if(activeTab === "region"){
                        setLocations(res?.data?.result?.length ? [...res?.data?.result] : []);
                        setRegionLocations(res?.data?.result?.length ? res.data.result.map(item => item.value) : [])
                    // }
                    // else                        
                    //     setLocations(res?.data?.result?.length ? [{label: "All", value: "All"},...res?.data?.result] : []);
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    useEffect(() => {
        loadLanguages();
        loadCategories();
        loadLocations();
        loadRevenueStats(userType);
        // loadNewspapers();
    }, [activeTab, userType])

    const loadRevenueData = async (dateRange, source, userType) => {
        try {
            if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && activeTab === "revenue_estimates") {
                setLoader(true);
                let res = await api({
                    url: `/competitor_reports/getRevenueEstimates`,
                    method: "POST",
                    responseType: "json",
                    data: {
                        dateRange,
                        source,
                        userType
                    }
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    setRevenueEstimates(res?.data?.data ? res?.data?.data : []);
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    useEffect(() => {
        loadRevenueData(dateRange, source, userType);
    }, [dateRange, source, activeTab, userType]);

    const loadThisMonthData = async (userType) => {
        try {
            if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && activeTab === "this_month") {
                setLoader(true);
                let res = await api({
                    url: `/competitor_reports/getThisMonthReports`,
                    method: "POST",
                    responseType: "json",
                    data: { userType }

                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    setThisMonthReports(res?.data?.result?.data ? res?.data?.result?.data : []);
                    setTotalThisMonthBrands(res?.data?.result?.totalBrands ? res?.data?.result?.totalBrands : 0);
                    setTotalThisMonthRevenue(res?.data?.result?.totalRevenue ? res?.data?.result?.totalRevenue : 0);
                    setTotalThisMonthCampaigns(res?.data?.result?.totalCampaigns ? res?.data?.result?.totalCampaigns : 0);

                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }
    const loadNewspaperLocations = async () => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) {
            const response = await api({
                url: `/birdview/newspaper_locations`,
                method: "POST",
                responseType: "json",
                data: { }
            });
            if (response?.code === 200) {
                setNewspaperLocations(response?.data?.result);
                if(newspaperLocationsObject.length === 0){
                    setNewspaperLocationsObject(response?.data?.result)
                }
            } else {
                toast.error(response?.data?.message)
            }
        }
    };
    useEffect(() => {
        loadThisMonthData(userType);
    }, [activeTab, userType]);

    const loadActiveBrands = async (reqObj) => {
        try {
            if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops)) {
                setOpen(true)
                setSummaryPayload({url: `/print_data/getActiveCampaigns`, payload: {...reqObj, brand_types: regionQueryBrandType, isAlpha : false}})
                return;
                setLoader(true);
                let res = await api({
                    url: `/competitor_reports/getActiveBrands`,
                    method: "POST",
                    responseType: "json",
                    data: {...reqObj, selectedBrandTypes: regionQueryBrandType}
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    setBrandsList(res?.data?.length ? res?.data : []);
                    const summaryMap = { total_count : 0, total_spent:0};
                    (res.data || []).forEach(item => {
                        const date = formatDate(item.date);
                        if(!summaryMap[date]) summaryMap[date] = { count : 0, spent : 0, ad_formats : [] };

                        summaryMap[date].ad_formats?.push(item?.ad_format);
                        summaryMap[date].count += 1;
                        summaryMap[date].spent += +item?.estimated_value;

                        summaryMap.total_count += 1;
                        summaryMap.total_spent += +item?.estimated_value;
                    });
                    setSummaryData(summaryMap);
                    
                    
                    // let array = res?.data?.length ? res?.data : [], finalSum =[];
                    // array.map(item => {
                    //     let tempObj = finalSum.find(tempitem => tempitem['newspaper_name'] === item.newspaper_name && tempitem['date'] === item.date && tempitem['brand_name'] === item.brand_name && tempitem['ad_format'] === item.ad_format)
                    //     if(Object.keys(tempObj).length){
                    //         tempObj.count += 1;
                    //         tempObj.spent += item.estimated_value

                    //     }
                    //     else{
                    //         finalSum.push({newspaper_name: item.newspaper_name, date: item.date, brand_name: item.brand_name, ad_format: item.ad_format, count: 1, spent: item.spent})
                    //     }
                    // })
                    // setRegionSummary([])
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response?.status === 401)
                navigate("/")
        }
    }

    const loadRegionReports = async (regionDateRange) => {
        try {
            if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && activeTab === "region") {
                setLoader(true);
                let res = await api({
                    url: `/competitor_reports/getRegionReports`,
                    method: "POST",
                    responseType: "json",
                    data: { regionDateRange, selectedSources, selectedBrandTypes: regionQueryBrandType }
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    setRegionReports(res?.data || {});
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    useEffect(() => {
        loadRegionReports(regionDateRange, selectedSources);
    }, [activeTab, regionDateRange, selectedSources, regionQueryBrandType]);

    const handlew2top = async(queryDateRange, queryLang, queryAdType, queryCategory, queryLocation, queryMedia,selectedQuery,queryBrandType) =>{
    
        try{

            let upto;
            if(selectedQuery==='top_50_brands')
                upto=50;
            if(selectedQuery==='top_20_brands')
                upto=20;
                
            if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && activeTab === "query") {
                setLoader(true);
                let res = await api({
                    url: `/competitor_reports/getTopQueryResult`,
                    method: "POST",
                    responseType: "json",
                    data: {
                        queryDateRange,
                        queryLang,
                        queryAdType,
                        queryCategory,
                        queryLocation,
                        queryMedia,
                        upto,
                        queryBrandType,
                        selectedQuery,
                    }
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                }
                else if(selectedQuery==='category_wise')
                {
                    setQueryData(res?.data?.result?.categoryTotalsArray);
                    setwayBrandTotal(res?.data?.result?.way_totalSum);
                    setAllBrandTotal(res?.data?.result?.compet_totalSum);

                }
                else{
                    setQueryData(res?.data?.result?.mergedResult);
                    setway2Brandcount(res?.data?.result?.totalwaybrandcount);
                    setAllBrandTotal(res?.data?.result?.totalcompetitorvalue);
                    setwayBrandTotal(res?.data?.result?.totalway2value);
                    setcompcount(res?.data?.result?.compBrandcount ? res?.data?.result?.compBrandcount : 0);

                }
                setLoader(false);
            }

        }catch(error)
        {
            setLoader(false);
            if (error.response.status === 401)
            navigate("/")
        }
    }
    const loadQueryResult = async (queryDateRange, queryLang, queryAdType, queryCategory, queryLocation, queryMedia, selectedQuery, queryBrandType) => {
        try {
            if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && activeTab === "query") {
                setLoader(true);
                let res = await api({
                    url: `/competitor_reports/getQueryResult`,
                    method: "POST",
                    responseType: "json",
                    data: {
                        queryDateRange,
                        queryLang,
                        queryAdType,
                        queryCategory,
                        queryLocation,
                        queryMedia,
                        selectedQuery,
                        queryBrandType
                    }
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    if (selectedQuery === "all_brands" || selectedQuery === "top_20_brands" || selectedQuery === "top_50_brands") {
                        setAllBrandTotal(res?.data?.result?.totalcompetitorvalue ? res?.data?.result?.totalcompetitorvalue : 0)
                        setQueryData(res?.data?.result?.mergedResult ? res?.data?.result?.mergedResult : []);
                        setway2Brandcount(res?.data?.result?.wayBrandCount ? res?.data?.result?.wayBrandCount : 0);
                        setwayBrandTotal(res?.data?.result?.totalway2value ? res?.data?.result?.totalway2value : 0);
                        setcompcount(res?.data?.result?.compBrandcount ? res?.data?.result?.compBrandcount : 0);

                    }
                    if (selectedQuery === "all_campaigns") {
                        setQueryData(res?.data?.result?.res ? res?.data?.result?.res : []);
                        setAllBrandTotal(res?.data?.result?.totalSum ? res?.data?.result?.totalSum : 0);
                        setway2Brandcount(res?.data?.result?.wayData[0]?.brand_count ? res?.data?.result?.wayData[0]?.brand_count : 0);
                        setwayBrandTotal(res?.data?.result?.wayData[0]?.total_value ? res?.data?.result?.wayData[0]?.total_value : 0);
                    }
                    if (selectedQuery === "category_wise") {
                        setQueryData(res?.data?.result?.categoryTotalsArray ? res?.data?.result?.categoryTotalsArray : []);
                        setAllBrandTotal(res?.data?.result?.compet_totalSum ? res?.data?.result?.compet_totalSum : 0);
                        setwayBrandTotal(res?.data?.result?.way_totalSum ? res?.data?.result?.way_totalSum : 0);
                    }
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }
    const handleCheckboxChange =(slectedQuery)=>{
        const newchecked=!checked;
        setChecked(newchecked);

       
    }
    useEffect(() => {
        if(checked)
            {
                handlew2top(queryDateRange, queryLang, queryAdType, queryCategory, queryLocation, queryMedia, selectedQuery, queryBrandType);
            }
            else
            {   
                loadQueryResult(queryDateRange, queryLang, queryAdType, queryCategory, queryLocation, queryMedia, selectedQuery, queryBrandType);
            }
    }, [queryDateRange, queryLang, queryAdType, queryCategory, queryLocation, queryMedia, selectedQuery, activeTab, userType, queryBrandType,checked]);

    const currentDate = new Date();
    const firstDayOfThisMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const thiMonthDates = [];
    for (let i = currentDate.getDate() - 1; i >= 0; i--) {
        const rowDate = new Date(firstDayOfThisMonth);
        rowDate.setDate(rowDate.getDate() + i);
        const formattedDate = `${rowDate.getFullYear()}-${(rowDate.getMonth() + 1).toString().padStart(2, '0')}-${rowDate.getDate().toString().padStart(2, '0')}`;
        thiMonthDates.push(formattedDate);
    }

    const startDate = new Date(regionDateRange.startDate); // Replace with your start date
    const endDate = new Date(regionDateRange.endDate);   // Replace with your end date
    const dateArray = [];
    let regionTotalData = {}, regionAllTotal = 0;

    // Loop through the range of dates
    for (let currentDate = new Date(startDate); currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
        const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
        dateArray.push(formattedDate);
    }


    function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }

    const handleClose = () => {
        setOpen(false);
        setView(false)
    };

    const handleSourceChange = (value) => {
        setSelectedSources(value)
    };
                console.log(reportId)

    const loadBrandCampaigns = async (name, queryDateRange, queryLang, queryAdType, queryCategory, queryLocation, queryMedia, selectedQuery) => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) {
                // const { name, userType, adType, dateRange = {}, newspapers = [], language = [], districts = [], category = [], sub_category = [], selectedQuery = "", field_id, ad_formats = [], limit = 100, page = 0 } = body;
            setSummaryPayload({url: `/print_data/getCampaigns`, payload: { name, userType, dateRange: queryDateRange, language: queryLang, adType: queryAdType, category: queryCategory, districts: queryLocation, newspapers: queryMedia, selectedQuery }})
            return;
            setLoader(true);
            let res = await api({
                url: `/competitor_reports/getCampaigns`,
                method: "POST",
                responseType: "json",
                data: {
                    name,
                    userType,
                    queryDateRange,
                    queryLang,
                    queryAdType,
                    queryCategory,
                    queryLocation,
                    queryMedia,
                    selectedQuery
                }
            });
            if (res?.code !== 200) {
                toast.error(res?.data?.message)
            } else {
                await loadNewspaperLocations()
                setCampaigns(res?.data?.result ? res?.data?.result : []);
                setLoader(false);
                if(selectedQuery === 'all_brands' || selectedQuery === 'top_20_brands' || selectedQuery === 'top_50_brands'){
                    let interableData = res?.data?.result || [], finalSum = []
                    interableData.map(item => {
                        if(!finalSum[item.date]){
                            finalSum[item.date] = {count: 0, ad_format: [], spent: 0}
                        }
                            finalSum[item.date].count += 1;
                            finalSum[item.date].spent += +item.estimated_value;
                            finalSum[item.date].ad_format = [...new Set([...finalSum[item.date].ad_format, item.ad_format])]
                    })
                    finalSum = Object.fromEntries(
                        Object.entries(finalSum).sort(([dateA], [dateB]) => dateA - dateB)
                      );
                    setSummary(finalSum)
                }
                else{
                    setSummary([])
                }
            }
        }
    };


    const userDetails = async () => {
        if (localStorage.getItem('role') === roles.salesperson) {

            let headDetails = await api({
                url: `/birdview/userDetails`,
                method: "POST",
                responseType: "json"
            });
            if (headDetails.data) {
                const userData = headDetails?.data?.result
                if (userData.user_type === -1) {
                    setUserType("MainHead");
                    setQueryAdType("All")
                }
                else if (userData.user_type === 1 && userData.region === -1 && userData.location === -1) {
                    setUserType("NationalHead");
                    setQueryAdType("All")
                }
                else if (userData.user_type === 2 && userData.region === -1 && userData.location === -1) {
                    setUserType("LocalHead")
                    setQueryAdType("All")

                }
                else if (userData.user_type === 1 && userData.region !== -1 && userData.location === -1) {
                    setUserType("RegionHead");
                    setQueryAdType("All")
                }
                else if (userData.user_type === 1 && userData.region !== -1 && userData.location !== -1) {
                    setUserType("NationalUser")
                    setQueryAdType("All")
                }
                else if (userData.user_type === 2 && userData.region !== -1) {
                    setUserType("LocalUser")
                    setQueryAdType("All")

                }

            }
        }
    }
    useEffect(()=>{
        getDistricts();
      },[])
    
    const handleDistrict = async(e) =>{
      setSelectedDistricts(e);
      try {
        const res = await api({ url: `/competitor_reports/getBrandLocations`, method: "POST", data: {dist_id:e?.dist_id} });
        if (res.code === 200) {
            const districts = res.data.map((item) => item.brand_location);
            setQueryLocation(districts);
        }
      } catch (error) {}
    }
    useEffect(() => {
        userDetails();
        fetchNewsPapers();
    }, [])
    const defaultValue = (options, value) => {
        return options ? options.filter((option) => option.value === value) : "";
      };

      const csvLinkRef = useRef(); // Create a ref for CSVLink
      let csvHeaders = [
        { label: "Brand Name", key: "brand_name" },
        { label: 'Brand Id', key: 'brand_id' },
        { label: "Way2news Value", key: "way2news_value" },
        { label: "Competitor Value", key: "competitor_value" },
        { label: "Brand Ad Type", key: "brand_ad_type"},
        { label: "Sales Person Name",key:"sales_person_name"},
        { label: "Brand Location", key: "brand_location"},
        { label: "Brand Category", key:"brand_category"},
        {label:"Brand Type", key:"brand_type"}
    ];
    const csvLinkRef2=useRef();
    let CompetitorcsvHeaders = [
      { label: "Brand Name", key: "brand_name" },
      { label: "Brand Category" , key:"brand_category"},
      { label: "Brand Location", key:"brand_location"},
      { label: "Sales Person", key:"sales_person_name"},
      { label: "Brand Ad Type", key:"brand_ad_type"},
      { label: 'Date', key: 'date' },
      { label: "Count", key: "count" },
      { label: "Ad Formats", key: "ad_formats" },
      { label: "Estimated Value", key: "total_estimated_value"}
  ];
  const getDownloadQueryData = async(brand_ids) => {
    if(brand_ids.length == 0)
    {
        Toast("info","No data to Download");
        return;
    }
    try {
        setDownloadLoader(true);
        let apiResp = await api({
            url: "/competitor_reports/getDownloadQueryData",
            method: "POST",
            responseType: "json",
            data: {
                queryDateRange,
                queryLang,
                queryMedia,
                brand_ids
            }
        })
        if(apiResp.code === 200){
            setDownloadQueryoldData(apiResp.data)
        }
        setDownloadLoader(false);
    } catch (error) {
        console.error("Error @ getDownloadQueryData", error)
    }
}
    const getDownloadQueryDatanew = () => {
        try {
            setDownloadLoadernew(true);
            if(queryData?.length)
            {
                setDownloadQueryData(queryData);
            }
            setDownloadLoadernew(false);
        } catch (error) {
            console.error("Error @ getDownloadQueryData", error)
        }
    }
    useEffect(() => {
        if (downloadQueryData.length) {
            csvLinkRef?.current?.link?.click();
            setDownloadQueryData([]);
        }
      }, [downloadQueryData]);
    useEffect(()=>{
        console.log("data",downloadQueryoldData);
        if(downloadQueryoldData.length){
            csvLinkRef2?.current?.link?.click();
            setDownloadQueryoldData([]);
        }
    },[downloadQueryoldData]);

    const w2nCsvHeaders = [
      { label: "Sales Person Name", key: "sales_person_name" },
      { label: "Day", key: "date" },
      { label: "Amount", key: "amount" }
    ];

    const getDownloadW2NData = async (brand_ids = null) => {
      try {
        setDownloadW2NLoader(true);
        let data = { queryDateRange };
        // If brand_ids are provided (for top 20/50), include them in the request
        if (brand_ids && Array.isArray(brand_ids) && brand_ids.length > 0) {
          data.brand_ids = brand_ids;
        }
        let apiResp = await api({
          url: "/competitor_reports/getDownloadw2nData",
          method: "POST",
          responseType: "json",
          data
        });
        if (apiResp.code === 200) {
          const formattedData = apiResp.data.result.map(item => ({
            ...item,
            date: formatDate(item.date),
          }));
          setDownloadW2NData(formattedData);
        }
        setDownloadW2NLoader(false);
      } catch (error) {
        setDownloadW2NLoader(false);
        console.error("Error @ getDownloadW2NData", error);
      }
    };

    useEffect(() => {
      if (downloadW2NData.length) {
        csvLinkRefW2N?.current?.link?.click();
        setDownloadW2NData([]);
      }
    }, [downloadW2NData]);

    return (
        <div className='printData'>
        <ScrollContainer>
            <table class="table table-bordered revenueEstimation">
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        {
                            revenueStats.headers?.map(newspaper_name => 
                                (<th>{newspaper_name}</th>)
                            )
                        }
                        <th>Total Print Revenue</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Yesterday</td>
                        {
                            revenueStats.headers?.map(newspaper_name => {
                                let tempYest = revenueStats.yesterdayResult?.find(yesItem => yesItem.newspaper_name === newspaper_name)
                                if(tempYest){
                                    return (<td style={{color: newspaperData?.find(item => item.name === newspaper_name)?.background_color || ""}}  data-toggle="tooltip" data-placement="top" title={tempYest.yesterday_revenue}>₹{formatAmount(tempYest.yesterday_revenue)}</td>)
                                }
                                else
                                    return <td style={{color: newspaperData?.find(item => item.name === newspaper_name)?.background_color || ""}}>₹0</td>
                            })
                        }
                        <td class="total" data-toggle="tooltip" data-placement="top" title={revenueStats?.yesterdayTotal}>₹{formatAmount(revenueStats?.yesterdayTotal)}</td>
                    </tr>
                    <tr>
                        <td>This Month</td>
                        {
                            revenueStats.headers?.map(newspaper_name => {
                                let tempthismonth = revenueStats.thisMonthResult?.find(thismonthItem => thismonthItem.newspaper_name === newspaper_name)
                                if(tempthismonth)
                                    return (<td style={{color: newspaperData?.find(item => item.name === newspaper_name)?.background_color || ""}} data-toggle="tooltip" data-placement="top" title={tempthismonth.this_month_revenue}>₹{formatAmount(tempthismonth.this_month_revenue)}</td>)
                                else
                                    return <td style={{color: newspaperData?.find(item => item.name === newspaper_name)?.background_color || ""}}>₹0</td>
                            })
                        }
                        {/* <td class="sakshi">₹{formatAmount(revenueStats.this_month_sakshi)}</td>
                        <td class="eenadu">₹{formatAmount(revenueStats.this_month_dinathanthi)}</td> */}
                        <td class="total" data-toggle="tooltip" data-placement="top" title={revenueStats?.thisMonthTotal}>₹ {formatAmount(revenueStats?.thisMonthTotal)}</td>
                    </tr>
                </tbody>
            </table>
            </ScrollContainer>
            <div className="card-body cc-body">
                <SlTabGroup >
                    {(localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && <SlTab slot="nav" panel="revenue_estimates" onClick={() => { handleTabClick("revenue_estimates") }}>Revenue Estimates
                    </SlTab>}
                    {/* {(localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) && <SlTab slot="nav" panel="this_month" onClick={() => { handleTabClick("this_month") }}>This Month
                    </SlTab>} */}
                    {(localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && <SlTab slot="nav" panel="region" onClick={() => { handleTabClick("region") }}>Region
                    </SlTab>}
                    {(localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && <SlTab slot="nav" panel="query" onClick={() => { handleTabClick("query") }}>Query
                    </SlTab>}

                    <SlTabPanel name="revenue_estimates">
                        <div className="cc-padding">
                            <div className="overflow-x-auto mb-4">

                                {/* <div class="selectors"> */}
                                <div className='flex gap-4 mb-4'>
                                    <div>
                                        <SlSelect
                                            className='w-full'
                                            placeholder="Select Media"
                                            name="source"
                                            size="medium"
                                            value={source}
                                            onSlChange={(e) => { setSource(e.target.displayLabel) }}

                                        >
                                            <SlOption key={0} value={'Media'}>Media</SlOption>
                                            {/* <SlOption key={0} value={'Channel'}>Channel</SlOption> */}
                                        </SlSelect>
                                    </div>

                                    <div className='border rounded-lg  border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66'>
                                        <Datepicker
                                            classNames="form-input"
                                            value={dateRange}
                                            primaryColor={"cyan"}
                                            showShortcuts={true}
                                            useRange={true} // Allow date range selection
                                            configs={{
                                                shortcuts: {
                                                    today: "today",
                                                    yesterday: "yesterday",
                                                    currentMonth: "currentMonth",
                                                    pastMonth: "lastMonth",

                                                }
                                            }}
                                            onChange={handleDateRange}
                                        />
                                    </div>

                                </div>
                                <div class="indiana-scroll-container indiana-scroll-container--hide-scrollbars">
                                    <table class="table table-bordered monthDate">
                                        <thead>
                                            <tr>
                                                <th>Edition</th>
                                                <th>Revenue</th>
                                                <th>Active Brands</th>
                                            </tr>
                                        </thead>
                                        {revenueEstimates.overAllData?.length ? <tbody>
                                            {
                                                 revenueEstimates.overAllData.map((item, index) => {
                                                    return(
                                                        <tr>
                                                        <td className={index%3 === 0 ? "ap" : index%3 ===1 ? "ts" : "hyd"}>{item.edition}</td>
                                                        <td data-toggle="tooltip" data-placement="top" title={item.estimated_value}>₹ {formatAmount(item.estimated_value)} ({calculatePercentage(item.estimated_value, revenueEstimates.totalRevenue)}%)</td>
                                                        <td>{item.brands_count}</td>
                                                        </tr>
                                                    )
                                                }) 
                                            }
                                        </tbody> : <NoDataFound colspan="8" />}
                                        <tfoot>
                                            <tr>
                                                <td>Total</td>
                                                <td data-toggle="tooltip" data-placement="top" title={revenueEstimates.totalRevenue}>₹ {formatAmount(revenueEstimates.totalRevenue)}</td>
                                                <td>{revenueEstimates.totalBrandsCount}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </SlTabPanel>

                    <SlTabPanel name="this_month">
                        <div className="cc-padding">
                            <div className="overflow-x-auto mb-4">
                                <table class="table table-bordered monthDate">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Revenue</th>
                                            <th>Active Brands</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {thiMonthDates.map((date, index) => {
                                            const matchingItem = thisMonthReports.find((item) => item.event_day === date);
                                            return (
                                                <tr key={index}>
                                                    <td>{date}</td>
                                                    <td data-toggle="tooltip" data-placement="top" title={matchingItem ? matchingItem.total_estimated_value : 0}>₹ {matchingItem ? formatAmount(matchingItem.total_estimated_value) : 0}</td>
                                                    <td>
                                                        <div class="brands">
                                                            <div class="count">
                                                                <img src={MikeImage} alt="" />
                                                                <p class="success" style={{ cursor: "pointer" }} onClick={async () => {
                                                                    if (matchingItem) {
                                                                        // setOpen(true);
                                                                        // setBrandDate(matchingItem.event_day);
                                                                        // await loadActiveBrands(matchingItem.event_day, userType);
                                                                    }
                                                                }}>
                                                                    {matchingItem ? matchingItem.unique_brand_count : 0}
                                                                </p>
                                                            </div>
                                                            <div class="count">
                                                                <img src={LocationImage} alt="" />
                                                                <p style={{ cursor: "pointer" }} onClick={async () => {
                                                                    if (matchingItem) {
                                                                        setCampaignDate(matchingItem.event_day);
                                                                    }
                                                                }}>
                                                                    {matchingItem ? matchingItem.total_records : 0}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>


                                    <tfoot>
                                        <tr>
                                            <td>Total</td>
                                            <td data-toggle="tooltip" data-placement="top" title={totalThisMonthRevenue}>₹ {formatAmount(totalThisMonthRevenue)}</td>
                                            <td>
                                                <div class="brands">
                                                    <div class="count">
                                                        <img src={MikeImage} alt="" />
                                                        <p class="success" style={{ cursor: "pointer" }} onClick={async () => {
                                                            //  setTillToday({ Today: today.toISOString(), FirstDayOfMonth: firstDayOfMonth.toISOString() });
                                                        //  await loadActiveBrands({ Today: today.toISOString(), FirstDayOfMonth: firstDayOfMonth.toISOString() }, userType);
                                                        //   setOpen(true) 
                                                         }}>{totalThisMonthBrands}</p>
                                                    </div>
                                                    <div class="count">
                                                        <img src={LocationImage} alt="" />
                                                        <p>{totalThisMonthCampaigns}</p>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </SlTabPanel>

                    <SlTabPanel name="region">
                        <div className="prntDataRegion">
                            <div className="overflow-x-auto mb-4">
                                {/* <h1>Region Table</h1> */}
                                <div className='flex gap-4 mb-4'>

                                    <div>
                                        <SlSelect
                                            className=' mb-3 w-full'
                                            placeholder="Select Media"
                                            name="selectedSources"
                                            size="medium"
                                            value={selectedSources}
                                            onSlChange={(e) => { handleSourceChange(e.target.value); }}
                                            multiple
                                            clearable
                                        >
                                            {newspaperData?.map(item => (
                                                <SlOption key={item.name} value={item.name}>
                                                    {item.name}
                                                </SlOption>
                                            ))}

                                        </SlSelect>
                                    </div>

                                    <div className='border rounded-lg border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 datePicker'>
                                        <Datepicker
                                            classNames="form-input"
                                            value={regionDateRange}
                                            primaryColor={"cyan"}
                                            showShortcuts={true}
                                            useRange={true} // Allow date range selection
                                            configs={{
                                                shortcuts: {
                                                    today: "today",
                                                    yesterday: "yesterday",
                                                    currentMonth: "currentMonth",
                                                    pastMonth: "lastMonth",

                                                }
                                            }}
                                            onChange={handleRegionDateRange}
                                        />
                                    </div>   
                                    <div className="">
                                    <Select
                                        className='mb-3'
                                        placeholder="Select Brand Type"
                                        name="queryAdType"
                                        size="medium"
                                        value={BrandsTypes.filter(
                                            (option) => regionQueryBrandType.indexOf(option.value) >= 0
                                        )}
                                        onChange={(selected) => {
                                            setRegionQueryBrandType(
                                                selected ? selected.map((item) => item.value) : []
                                            );
                                        }}
                                        options={BrandsTypes}
                                        isMulti
                                    />
                                </div>                                

                                </div>
                                {/* <div className="printRegionLocations">
                                        <Select
                                    className='mb-3'
                                    placeholder="Select Location"
                                    name="queryLocation"
                                    size="medium"
                                    value={locations.filter(
                                        (option) => regionLocations.indexOf(option.value) >= 0
                                      )}
                                    onChange={(selected) => {
                                        setRegionLocations(
                                          selected ? selected.map((item) => item.value) : []
                                        );
                                      }}                                    
                                    options={locations}
                                    isMulti
                                />
                            </div> */}
                                <table class="table table-bordered monthDate specialTable regionTable">
                                    {dateArray?.length && !loader ? (<>
                                        <thead>
                                            <tr>
                                                <th class="first">&nbsp;</th>
                                                {selectedSources.map(item => <th colSpan={2}><img src={newspaperData.find(newsItem => newsItem.name === item)?.logo} alt="logo" /></th>)}
                                                <th colSpan={2}>Total</th>
                                            </tr>

                                        </thead>

                                        <tbody>
                                            {dateArray.map((date, index) => {

                                                let dateFilterReport = regionReports?.regularData?.length ? regionReports?.regularData?.filter(item => item.date === date) : []
                                                let totalDateFilterReport = regionReports?.totalDateWiseData?.find(item => item.date === date) || {}
                                                return (
                                                    <tr key={index}>
                                                        <td className="first">{date}</td>
                                                        {selectedSources.map(newsPaper => {
                                                            let item = dateFilterReport.find(dateItem => dateItem.newspaper_name === newsPaper);
                                                            return (<><td data-toggle="tooltip" data-placement="top" title={item?.total_estimated_value || 0}>₹{formatAmount(item?.total_estimated_value || 0)}</td>
                                                                <td><div class="brands">
                                                                    <div class="count">
                                                                        <img src={MikeImage} alt="" />
                                                                        <p class="success" style={{ cursor: "pointer" }} onClick={async () => {
                                                                            loadActiveBrands({ dateRange: { startDate: date, endDate: date }, newspapers: [newsPaper] })
                                                                        }}>
                                                                            {item?.brand_ids?.length || 0}
                                                                        </p>
                                                                    </div>
                                                                    <div class="count">
                                                                        <img src={LocationImage} alt="" />
                                                                        <p style={{ cursor: "pointer" }} >
                                                                            {item?.count || 0}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                </td></>)


                                                        })}
                                                        <td data-toggle="tooltip" data-placement="top" title={totalDateFilterReport.total_estimated_value || 0}>₹{formatAmount(totalDateFilterReport.total_estimated_value || 0)}</td>
                                                        <td><div class="brands">
                                                            <div class="count">
                                                                <img src={MikeImage} alt="" />
                                                                <p class="success" style={{ cursor: "pointer" }} onClick={async () => {
                                                                    loadActiveBrands({ dateRange: { startDate: date, endDate: date }, newspapers: selectedSources })
                                                                }}>
                                                                    {totalDateFilterReport?.brand_ids?.length || 0}
                                                                </p>
                                                            </div>
                                                            <div class="count">
                                                                <img src={LocationImage} alt="" />
                                                                <p style={{ cursor: "pointer" }}>
                                                                    {totalDateFilterReport?.count || 0}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                        <tfoot>
                                            <tr >
                                                <td>Total</td>
                                                {selectedSources.map(newsPaper => {
                                                    let totalNewsData = regionReports?.totalNewsWiseData?.find(item => item.newspaper_name === newsPaper)
                                                    return <><td data-toggle="tooltip" data-placement="top" title={totalNewsData?.total_estimated_value || 0}>₹{formatAmount(totalNewsData?.total_estimated_value || 0)}</td><td><div class="brands flex-wrap">
                                                        <div class="count">
                                                            <img src={MikeImage} alt="" />
                                                            <p class="success" style={{ cursor: "pointer" }} onClick={async () => {
                                                                loadActiveBrands({ newspapers: [newsPaper], dateRange: regionDateRange })
                                                            }}>
                                                                {totalNewsData?.brand_ids?.length || 0}
                                                            </p>
                                                        </div>
                                                        <div class="count">
                                                            <img src={LocationImage} alt="" />
                                                            <p style={{ cursor: "pointer" }}>
                                                                {totalNewsData?.count || 0}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    </td></>
                                                }
                                                )}
                                                <td data-toggle="tooltip" data-placement="top" title={regionReports?.overAllTotalData?.total_estimated_value || 0}>₹{formatAmount(regionReports?.overAllTotalData?.total_estimated_value || 0)}</td>
                                                <td><div class="brands flex-wrap">
                                                    <div class="count">
                                                        <img src={MikeImage} alt="" />
                                                        <p class="success" style={{ cursor: "pointer" }} onClick={async () => {
                                                            loadActiveBrands({ dateRange: regionDateRange, newspapers: selectedSources })
                                                        }}>
                                                            {regionReports?.overAllTotalData?.brand_ids?.length || 0}
                                                        </p>
                                                    </div>
                                                    <div class="count">
                                                        <img src={LocationImage} alt="" />
                                                        <p style={{ cursor: "pointer" }}>
                                                            {regionReports?.overAllTotalData?.count || 0}
                                                        </p>
                                                    </div>
                                                </div>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </>) : !dateArray?.length && !loader ? (
                                        <NoDataFound colspan={3} />
                                    ) : (
                                        <TableSkelton colspan={3} />
                                    )}
                                </table>
                            </div>
                        </div>
                    </SlTabPanel>

                    <SlTabPanel name="query">
                        <div className="customHeight">
                            <div>
                                <SlSelect
                                    style={{ width: 650 }}
                                    className=' mb-3 w-full'
                                    placeholder="Select Language"
                                    name="queryLang"
                                    size="medium"
                                    value={queryLang}
                                    onSlChange={(e) => { handleQueryLang(e.target.value); }}
                                    multiple
                                    clearable

                                >
                                    {languages?.map(item => (
                                        <SlOption key={item.lang_id} value={item.lang_id}>
                                            {item.lang_name}
                                        </SlOption>
                                    ))}

                                </SlSelect>
                            </div>

                            <div>
                                <SlSelect
                                    style={{ width: 650 }}
                                    className='mb-3'
                                    placeholder="Select Ad Type"
                                    name="queryAdType"
                                    size="medium"
                                    value={queryAdType}
                                    onSlChange={(e) => { setQueryAdType(e.target.value) }}

                                >
                                    <>
                                        <SlOption key={0} value={'All'}>All</SlOption>
                                        <SlOption key={1} value={"Finite"}>Finite</SlOption>
                                        <SlOption key={2} value={"Infinite"}>Infinite</SlOption>
                                    </>
                                    {/* {(userType === "LocalHead" || userType === "LocalUser") ? (
                                        <>
                                            <SlOption key={1} value={"Local"}>Local</SlOption>
                                            <SlOption key={2} value={"District"}>District</SlOption>
                                        </>) : (userType === "NationalHead" || userType === "RegionHead" || userType === "NationalUser" ? (<SlOption key={0} value={"National"}>National</SlOption>) : (
                                            <>
                                                <SlOption key={0} value={'All'}>All</SlOption>
                                                <SlOption key={1} value={"National"}>National</SlOption>
                                                <SlOption key={2} value={"Local"}>Local</SlOption>
                                                <SlOption key={3} value={"District"}>District</SlOption>
                                            </>
                                        ))} */}


                                    {/* {adTypes?.map(item => (
                                        <SlOption key={item.value} value={item.value}>
                                            {item.label}
                                        </SlOption>
                                    ))} */}
                                </SlSelect>
                            </div>
                            <div>
                                <SlSelect
                                    style={{ width: 650 }}
                                    className='mb-3'
                                    placeholder="Select Ad Type"
                                    name="queryAdType"
                                    size="medium"
                                    value={queryBrandType}
                                    onSlChange={(e) => { setQueryBrandType(e.target.value) }}

                                >
                                    <>
                                        <SlOption key={0} value={'All'}>All</SlOption>
                                       {BrandsTypes.map((type)=>
                                    <SlOption key={type.value} value={+type.value}>{type.label}</SlOption>)}
                                    </>
                                </SlSelect>
                            </div>
                            <div style={{ width: 650 }}>
                            <Select
                                className='mb-3'
                                placeholder="Select District"
                                size="medium"
                                value={selectedDistricts || null}   // only for this row
                                onChange={handleDistrict}
                                options={district}
                                getOptionLabel={(option) => option.dist_name}
                                getOptionValue={(option) => option.dist_id}
                                isClearable
                            />
                            </div>
                            {/* {(queryAdType === "District") ? ( */}
                            <div style={{ width: 650 }}>
                                <Select
                                    className='mb-3'
                                    placeholder="Select Location"
                                    name="queryLocation"
                                    size="medium"
                                    value={locations.filter(
                                        (option) => queryLocation.indexOf(option.value) >= 0
                                      )}
                                    onChange={(selected) => {
                                        const newSelection = selected ? selected.map((item) => item.value) : [];
                                        setQueryLocation(
                                          selected ? selected.map((item) => item.value) : []
                                        );
                                        if (newSelection.length === 0) {
                                            setSelectedDistricts(null);
                                        }
                                      }}                                    
                                    options={locations}
                                    isMulti
                                />
                            </div>
                            {/* ) : null} */}

                            <div style={{ width: 650 }}>

                                <Select
                                    className='mb-3'
                                    placeholder="Select Media/Channel"
                                    name="queryMedia"
                                    size="medium"
                                    value={newspaperData.map(item => {return {label: item.name, value: item.name}}).filter(
                                        (option) => queryMedia.indexOf(option.value) >= 0
                                      )}
                                    onChange={(selected) => {
                                        setQueryMedia(
                                          selected ? selected.map((item) => item.value) : []
                                        );
                                      }}                                    
                                    options={newspaperData.map(item => {return {label: item.name, value: item.name}})}
                                    isMulti
                                />
                            </div>

                            <div style={{ width: 650 }}>
                                <Select
                                    className='mb-3'
                                    placeholder="Select Category"
                                    name="queryCategory"
                                    size="medium"
                                    value={categories.map(item => {return {label: item.category_name, value: item.category_id}}).filter(
                                        (option) => queryCategory.indexOf(option.value) >= 0
                                      )}
                                    onChange={(selected) => {
                                        setQueryCategory(
                                          selected ? selected.map((item) => item.value) : []
                                        );
                                      }}                                    
                                    options={categories.map(item => {return {label: item.category_name, value: item.category_id}})}
                                    isMulti
                                />
                            </div>

                            <div className='border rounded-lg  border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66 pickDate customFwidth'>
                                <Datepicker
                                    classNames="form-input"

                                    value={queryDateRange}
                                    primaryColor={"cyan"}
                                    showShortcuts={true}
                                    useRange={true} // Allow date range selection
                                    configs={{
                                        shortcuts: {
                                            today: "today",
                                            yesterday: "yesterday",
                                            currentMonth: "currentMonth",
                                            pastMonth: "lastMonth",

                                        }
                                    }}
                                    onChange={handleQueryDateRange}
                                />
                            </div>

                            <div className="addMore d-flex justify-between items-center w-full">
                                <ul className="chooseMore">
                                    <li>
                                        <input type="checkbox" id="brands" value="all_brands" checked={selectedQuery === 'all_brands'}
                                            onChange={() => handleSelectedQUery("all_brands")} />
                                        <label htmlFor="brands">All Brands</label>
                                    </li>
                                    <li>
                                        <input type="checkbox" id="campaigns" value="all_campaigns" checked={selectedQuery === 'all_campaigns'}
                                            onChange={() => handleSelectedQUery("all_campaigns")} />
                                        <label htmlFor="campaigns">All Campaigns</label>
                                    </li>
                                    {/* <li>
                                        <input type="checkbox" id="revenue" value="revenue_comparision" checked={selectedQuery === 'revenue_comparision'}
                                            onChange={() => handleSelectedQUery("revenue_comparision")} />
                                        <label htmlFor="revenue">Revenue Comparison</label>
                                    </li> */}
                                    <li>
                                        <input type="checkbox" id="top20" value="top_20_brands" checked={selectedQuery === 'top_20_brands'}
                                            onChange={() => handleSelectedQUery("top_20_brands")} />
                                        <label htmlFor="top20">Top 20 Brands</label>
                                    </li>
                                    <li>
                                        <input type="checkbox" id="top50" value="top_50_brands" checked={selectedQuery === 'top_50_brands'}
                                            onChange={() => handleSelectedQUery("top_50_brands")} />
                                        <label htmlFor="top50">Top 50 Brands</label>
                                    </li>
                                    <li>
                                        <input type="checkbox" id="category" value="category_wise" checked={selectedQuery === 'category_wise'}
                                            onChange={() => handleSelectedQUery("category_wise")} />
                                        <label htmlFor="category">Category Wise</label>
                                    </li>
                                </ul>
                                <div className="flex justify-end items-center gap-20">
                                {checked === false && (selectedQuery === 'all_brands' || selectedQuery === 'top_20_brands' || selectedQuery === 'top_50_brands') ? <div className="ml-auto">
                                    <CSVLink
                                        data={downloadQueryoldData.map(
                                            ({
                                                brand_name,
                                                brand_category,
                                                brand_location,
                                                sales_person_name,
                                                brand_ad_type,
                                                date,
                                                count,
                                                ad_formats,
                                                total_estimated_value
                                            }, index) => {
                                                const brand_category_name=categories.find((option) => option.category_id == brand_category)?.category_name || "-"

                                                let obj = {
                                                    brand_name: index === 0 || downloadQueryoldData[index - 1].brand_name !== brand_name ? brand_name : '',
                                                    brand_category:brand_category_name,
                                                    brand_location: brand_location ?? '-', 
                                                    sales_person_name,
                                                    brand_ad_type,
                                                    date: formatDate(date),
                                                    count,
                                                    ad_formats: ad_formats.join(', '),
                                                    total_estimated_value
                                                };
                                                return obj;
                                            }
                                        )}
                                        headers={CompetitorcsvHeaders}
                                        filename={`Summary.csv`}
                                        ref={csvLinkRef2} // Assign the ref to the CSVLink component
                                    ></CSVLink>
                                    {downloadLoader ? (
                                        <TableSkelton />
                                    ) : (<SlTooltip content="Summary">
                                        <SlIcon
                                            library="lucide"
                                            name="download"
                                            className="w-6 h-6"
                                            onClick={() => {
                                                getDownloadQueryData(queryData.map(item => item.brand_id))
                                            }}
                                        ></SlIcon>
                                    </SlTooltip>)}
                                </div> : null}
                                {checked === true && (selectedQuery === 'all_brands' || selectedQuery === 'top_20_brands' || selectedQuery === 'top_50_brands') ? (
                                  <div className="ml-auto">
                                    <CSVLink
                                      data={downloadW2NData }
                                      headers={w2nCsvHeaders}
                                      filename={`Way2newsWise.csv`}
                                      ref={csvLinkRefW2N}
                                    ></CSVLink>
                                    {downloadW2NLoader ? (
                                      <TableSkelton />
                                    ) : (
                                      <SlTooltip content="Download Way2news Wise">
                                        <SlIcon
                                          library="lucide"
                                          name="download"
                                          className="w-6 h-6"
                                          onClick={() => {
                                            // For top 20/50 brands, pass brand_ids; for all_brands, pass nothing
                                            if (selectedQuery === 'top_20_brands' || selectedQuery === 'top_50_brands') {
                                              getDownloadW2NData(queryData?.map(item => item?.brand_id));
                                            } else {
                                              getDownloadW2NData();
                                            }
                                          }}
                                        ></SlIcon>
                                      </SlTooltip>
                                    )}
                                  </div>
                                ) : null}
                                {selectedQuery === 'all_brands' || selectedQuery === 'top_20_brands' || selectedQuery === 'top_50_brands' ? <div className="ml-auto">
                                  
                                    <CSVLink
                                        data={[
                                            {
                                                brand_name: "Summary",
                                                brand_id: "",
                                                way2news_value: `Way2News Brands: ${way2Brandcount}, Value: ${wayBrandTotal}`,
                                                competitor_value: `Competitor Brands: ${compcount}, Value: ${allBrandTotal}`,
                                                brand_ad_type: "",
                                                brand_location: "",
                                                sales_person_name:"",
                                                brand_category:""
                                            },
                                            , ...downloadQueryData.map(
                                            ({
                                                brand_name,
                                                brand_id,
                                                way2news_value,
                                                competitor_value,
                                                brand_ad_type,
                                                brand_location,
                                                brand_type,
                                                sales_person_name,
                                                brand_category
                                            }, index) => {
                                              const new_brand_type=BrandsTypes.find(option => option.value === brand_type)?.label || "-"
                                              const brand_category_name=categories.find((option) => option.category_id == brand_category)?.category_name || "-"

                                                let obj = {
                                                    brand_name: index === 0 || downloadQueryData[index - 1].brand_name !== brand_name ? brand_name : '',
                                                    brand_id,
                                                    way2news_value,
                                                    competitor_value,
                                                    brand_ad_type,
                                                    sales_person_name : sales_person_name ? sales_person_name : "-",
                                                    brand_location : brand_location ? brand_location : "-",
                                                    brand_category:brand_category_name,
                                                    brand_type:new_brand_type       
                                                };
                                                return obj;
                                            }
                                        )]}
                                        headers={csvHeaders}
                                        filename={`${selectedQuery}.csv`}
                                        ref={csvLinkRef} // Assign the ref to the CSVLink component
                                    ></CSVLink>
                                    {downloadloadernew ? (
                                        <TableSkelton />
                                    ) : (<SlTooltip content="Download">
                                        <SlIcon
                                            library="lucide"
                                            name="download"
                                            className="w-6 h-6"
                                            onClick={() => {
                                                getDownloadQueryDatanew()
                                            }}
                                        ></SlIcon>
                                    </SlTooltip>)}
                                </div> : null}
                                </div>
                            </div>
                        </div>
                        {(selectedQuery === "all_brands") ? (< div className='overflow-x-auto mb-4' >
                        <div className="flex flex-wrap justify-evenly space x-4 my-3">
                            <div className="flex items-center">
                            <div className='toggle'>
                                    <span className={checked ? '' : 'active'} onClick={()=>{handleCheckboxChange(selectedQuery)}}>Competitor Wise</span>
                                    <span className={checked ? 'active' : ''} onClick={()=>{handleCheckboxChange(selectedQuery)}}>Way2news Wise</span>
                                </div>
                            </div>
                          
                           <span>Way2news Brand count: {way2Brandcount || 0}</span>
                           <span>Competitor Brand count: {compcount || 0}</span>
                        </div>
                            
                            
                            <table className='table table-bordered splTable'>
                                <tfoot className='show-footer-above'>
                                    <tr>
                                        <td><b>Total</b></td>
                                        <td></td>
                                        <td></td>
                                        <td data-toggle="tooltip" data-placement="top" title={allBrandTotal}><b>
                                            ₹{formatAmount(allBrandTotal)}
                                        </b>
                                        </td>
                                        <th data-toggle="tooltip" data-placement="top" title={wayBrandTotal}>
                                            ₹{formatAmount(wayBrandTotal)}
                                        </th>
                                    </tr>
                                </tfoot>
                                <thead className="sticky top-0 ">
                                    <tr>
                                        <th >Brand Name</th>
                                        <th>Sales Person</th>
                                        <th>Brand Location</th>
                                        <th>Competitor Value</th>
                                        <th>W2N Value</th>
                                    </tr>
                                </thead>
                                {queryData?.length && !loader ? (
                                    <tbody>
                                        {queryData.map((item, index) => {
                                            return (
                                                <tr key={item.id} className="group/details hover:bg-slate-100">
                                                    {/* <th scope='row' onClick={async () => { setName((item.brand_name)); setView(true); await loadBrandCampaigns(item.brand_id, queryDateRange, queryLang, queryAdType, queryCategory, queryLocation, queryMedia, selectedQuery) }} ><div>{item.brand_name}</div>{<span className="px-2 py-[2px] text-[10px] leading-3 bg-green-200 rounded-md mr-1">{item.brand_ad_type}</span>}<span className="px-2 py-[2px] text-[10px] leading-3 bg-blue-200 rounded-md">{BrandsTypes.find(option => option.value === item.brand_type)?.label || "-"}</span><span>{item.brand_location}</span><span>{item.sales_person_name}</span><span>{categories.find((option) => option.category_id === item.brand_categroy)?.category_name || "-"}</span></th> */}
                                                    <th
                                                    scope="row"
                                                    onClick={async () => {
                                                        setName(item.brand_name);
                                                        setView(true);
                                                        await loadBrandCampaigns(
                                                        item.brand_id,
                                                        queryDateRange,
                                                        queryLang,
                                                        queryAdType,
                                                        queryCategory,
                                                        queryLocation,
                                                        queryMedia,
                                                        selectedQuery
                                                        );
                                                    }}
                                                    className="cursor-pointer"
                                                    >
                                                        <div className="flex items-center space-x-2 mb-1">
                                                            <span className="font-medium">{item.brand_name}</span>
                                                        </div>

                                                        <div className="flex items-center space-x-1 flex-wrap">
                                                            <span className="px-2 py-[2px] text-[10px] leading-3 bg-green-200 rounded-md">
                                                            {item.brand_ad_type || "-"}
                                                            </span>

                                                            <span className="px-2 py-[2px] text-[10px] leading-3 bg-blue-200 rounded-md">
                                                            {BrandsTypes.find((option) => option.value === item.brand_type)?.label || "-"}
                                                            </span>

                                                            <span className="px-2 py-[2px] text-[10px] leading-3 bg-purple-200 rounded-md">
                                                            {categories.find((option) => option.category_id == item.brand_category)?.category_name || "-"}
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <td>
                                                    {item.sales_person_name || "-"}
                                                    </td>
                                                    <td>
                                                    {item.brand_location || "-"}
                                                    </td>
                                                    <td 
                                                        data-toggle="tooltip" 
                                                        data-placement="top" 
                                                        title={item.competitor_value}
                                                        >
                                                        {item.competitor_value !== "Not Found"
                                                            ? `₹${formatAmount(item.competitor_value)} (${calculatePercentage(item.competitor_value, allBrandTotal)}%)`
                                                            : "Not Found"}
                                                        </td>
                                                    <td data-toggle="tooltip" data-placement="top" title={item.way2news_value}>  {item.way2news_value !== "Not Found"
                                                            ? `₹${formatAmount(item.way2news_value)} (${calculatePercentage(item.way2news_value, wayBrandTotal)}%)`
                                                            : "Not Found"}</td></tr>
                                            )
                                        })}
                                    </tbody>
                                ) : ((!queryData?.length && !loader)
                                    ? <NoDataFound colspan="8" />
                                    : <TableSkelton colspan="3" rowSpan={20} />
                                )}

                            </table>
                        </div >) : null}
                        {(selectedQuery === "all_campaigns") ? (< div className='overflow-x-auto mb-4' >
                        <div className="flex  justify-evenly space my-3">
                        <p>Way2newsBrandcount: {way2Brandcount}</p>
                        <p>Way2newsTotalValue: {wayBrandTotal}</p>
                        </div>
                         
                            <table className='table table-bordered  splTable'>
                                <tfoot className='show-footer-above'>
                                    <tr>
                                        <th>Total</th>
                                        <th data-toggle="tooltip" data-placement="top" title={allBrandTotal}>
                                            ₹{formatAmount(allBrandTotal)}
                                        </th>
                                    </tr>
                                </tfoot>
                                <thead className="sticky top-0 ">
                                    <tr>
                                        <th >Campaign Name</th>
                                        <th>Value</th>
                                    </tr>
                                </thead>
                                {(queryData?.length && !loader) ? (
                                    <tbody>
                                        {queryData.map((item, index) => {
                                            return (
                                                <tr key={item.id} className="group/details hover:bg-slate-100">
                                                    <th scope='row' onClick={async () => { setName((item.ad_format)); setView(true); await loadBrandCampaigns(item.ad_format, queryDateRange, queryLang, queryAdType, queryCategory, queryLocation, queryMedia, selectedQuery) }} >{item.ad_format || "-"}</th>
                                                    <td data-toggle="tooltip" data-placement="top" title={item.total_estimated_value}>₹ {formatAmount(item.total_estimated_value) || "-"}({calculatePercentage(item.total_estimated_value, allBrandTotal)}%)</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>) : ((!queryData?.length && !loader)
                                        ? <NoDataFound colspan="8" />
                                        : <TableSkelton colspan="3" rowSpan={20} />
                                 )}
                            </table>
                        </div >) : null}
                        {(selectedQuery === "top_20_brands") ? (< div className='overflow-x-auto mb-4' >
                          <div className="flex justify-evenly my-3">
                            <div className="flex items-center">
                            <div className='toggle'>
                                    <span className={checked ? '' : 'active'} onClick={()=>{handleCheckboxChange(selectedQuery)}}>Competitor Wise</span>
                                    <span className={checked ? 'active' : ''} onClick={()=>{handleCheckboxChange(selectedQuery)}}>Way2news Wise</span>
                                </div>
                            </div>
                            <span>Way2news Brand count: {way2Brandcount || 0}</span>
                           <span>Competitor Brand count: {compcount || 0}</span>
                          </div>
                            <table className='table table-bordered  splTable'>
                                <tfoot className='show-footer-above'>
                                    <tr>
                                        <th>Total</th>
                                        <th></th>
                                        <th></th>
                                        <th data-toggle="tooltip" data-placement="top" title={allBrandTotal}>
                                            ₹{formatAmount(allBrandTotal)}
                                        </th>
                                        <th data-toggle="tooltip" data-placement="top" title={wayBrandTotal}>
                                            ₹{formatAmount(wayBrandTotal)}
                                        </th>
                                    </tr>
                                </tfoot>
                                <thead className="sticky top-0 ">
                                    <tr>
                                        <th>Brand Name</th>
                                        <th>Sales Person</th>
                                        <th>Brand Location</th>
                                        <th>Competitor Value</th>
                                        <th>W2N Value</th>
                                    </tr>
                                </thead>
                                {queryData?.length && !loader ? (
                            <tbody>
                                {queryData.map((item, index) => (
                                <tr key={item.id} className="group/details hover:bg-slate-100">
                                                <th
                                                    scope="row"
                                                    onClick={async () => {
                                                        setName(item.brand_name);
                                                        setView(true);
                                                        await loadBrandCampaigns(
                                                        item.brand_id,
                                                        queryDateRange,
                                                        queryLang,
                                                        queryAdType,
                                                        queryCategory,
                                                        queryLocation,
                                                        queryMedia,
                                                        selectedQuery
                                                        );
                                                    }}
                                                    className="cursor-pointer"
                                                    >
                                                        <div className="flex items-center space-x-2 mb-1">
                                                            <span className="font-medium">{item.brand_name}</span>
                                                        </div>

                                                        <div className="flex items-center space-x-1 flex-wrap">
                                                            <span className="px-2 py-[2px] text-[10px] leading-3 bg-green-200 rounded-md">
                                                            {item.brand_ad_type || "-"}
                                                            </span>

                                                            <span className="px-2 py-[2px] text-[10px] leading-3 bg-blue-200 rounded-md">
                                                            {BrandsTypes.find((option) => option.value === item.brand_type)?.label || "-"}
                                                            </span>

                                                            <span className="px-2 py-[2px] text-[10px] leading-3 bg-purple-200 rounded-md">
                                                            {categories.find((option) => option.category_id == item.brand_category)?.category_name || "-"}
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <td>
                                                    {item.sales_person_name || "-"}
                                                    </td>
                                                    <td>
                                                    {item.brand_location || "-"}
                                                    </td>
                                                      <td 
                                                        data-toggle="tooltip" 
                                                        data-placement="top" 
                                                        title={item.competitor_value}
                                                        >
                                                        {item.competitor_value !== "Not Found"
                                                            ? `₹${formatAmount(item.competitor_value)} (${calculatePercentage(item.competitor_value, allBrandTotal)}%)`
                                                            : "Not Found"}
                                                        </td>
                                                    <td data-toggle="tooltip" data-placement="top" title={item.way2news_value}>  {item.way2news_value !== "Not Found"
                                                            ? `₹${formatAmount(item.way2news_value)} (${calculatePercentage(item.way2news_value, wayBrandTotal)}%)`
                                                            : "Not Found"}</td></tr>
                                ))}
                            </tbody>
                            ) : !queryData?.length && !loader ? (
                            <NoDataFound colspan="8" />
                            ) : (
                            <TableSkelton colspan="8" />
                            )}

                            </table>
                        </div >) : null}
                        {(selectedQuery === "top_50_brands") ? (< div className='overflow-x-auto mb-4' >
                        <div className="flex justify-evenly my-3">
                          <div className="flex items-center">
                          <div className='toggle'>
                                    <span className={checked ? '' : 'active'} onClick={()=>{handleCheckboxChange(selectedQuery)}}>Competitor Wise</span>
                                    <span className={checked ? 'active' : ''} onClick={()=>{handleCheckboxChange(selectedQuery)}}>Way2news Wise</span>
                                </div>
                          </div>
                          <span>Way2news Brand count: {way2Brandcount || 0}</span>
                          <span>Competitor Brand count: {compcount || 0}</span>
    
                        </div>
                            <table className='table table-bordered  splTable'>
                                <tfoot className='show-footer-above'>
                                    <tr>
                                        <th>Total</th>
                                        <th></th>
                                        <th></th>
                                        <th data-toggle="tooltip" data-placement="top" title={allBrandTotal}>
                                            ₹{formatAmount(allBrandTotal)}
                                        </th>
                                        <th data-toggle="tooltip" data-placement="top" title={wayBrandTotal}>
                                            ₹{formatAmount(wayBrandTotal)}
                                        </th>
                
                                    </tr>
                                </tfoot>
                                <thead className="sticky top-0 ">
                                    <tr>
                                        <th>Brand Name</th>
                                        <th>Sales Person</th>
                                        <th>Brand Location</th>
                                        <th>Competitor Value</th>
                                        <th>W2N Value</th>
                                    </tr>
                                </thead>
                                {queryData?.length && !loader ? (
                                    <tbody>
                                        {queryData.map((item, index) => {
                                            return (
                                                <tr key={item.id} className="group/details hover:bg-slate-100">
                                                    <th
                                                    scope="row"
                                                    onClick={async () => {
                                                        setName(item.brand_name);
                                                        setView(true);
                                                        await loadBrandCampaigns(
                                                        item.brand_id,
                                                        queryDateRange,
                                                        queryLang,
                                                        queryAdType,
                                                        queryCategory,
                                                        queryLocation,
                                                        queryMedia,
                                                        selectedQuery
                                                        );
                                                    }}
                                                    className="cursor-pointer"
                                                    >
                                                        <div className="flex items-center space-x-2 mb-1">
                                                            <span className="font-medium">{item.brand_name}</span>
                                                        </div>

                                                        <div className="flex items-center space-x-1 flex-wrap">
                                                            <span className="px-2 py-[2px] text-[10px] leading-3 bg-green-200 rounded-md">
                                                            {item.brand_ad_type || "-"}
                                                            </span>

                                                            <span className="px-2 py-[2px] text-[10px] leading-3 bg-blue-200 rounded-md">
                                                            {BrandsTypes.find((option) => option.value === item.brand_type)?.label || "-"}
                                                            </span>

                                                            <span className="px-2 py-[2px] text-[10px] leading-3 bg-purple-200 rounded-md">
                                                            {categories.find((option) => option.category_id == item.brand_category)?.category_name || "-"}
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <td>
                                                    {item.sales_person_name || "-"}
                                                    </td>
                                                    <td>
                                                    {item.brand_location || "-"}
                                                    </td>
                                                    <td data-toggle="tooltip" data-placement="top" title={item.competitor_value}>{item.competitor_value !== "Not Found"
                                                            ? `₹${formatAmount(item.competitor_value)} (${calculatePercentage(item.competitor_value, allBrandTotal)}%)`
                                                            : "Not Found"}</td>
                                                    <td data-toggle="tooltip" data-placement="top" title={item.way2news_value}>  {item.way2news_value !== "Not Found"
                                                            ? `₹${formatAmount(item.way2news_value)} (${calculatePercentage(item.way2news_value, wayBrandTotal)}%)`
                                                            : "Not Found"}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>) : ((!queryData?.length && !loader)
                                        ? <NoDataFound colspan="8" />
                                        : <TableSkelton colspan="8" />
                                )}
                            </table>
                        </div >) : null}

                        {(selectedQuery === "category_wise") ? (< div className='overflow-x-auto mb-4' >
                        <div className="flex my-3">
                        <div className='toggle'>
                                    <span className={checked ? '' : 'active'} onClick={()=>{handleCheckboxChange(selectedQuery)}}>Competitor Wise</span>
                                    <span className={checked ? 'active' : ''} onClick={()=>{handleCheckboxChange(selectedQuery)}}>Way2news Wise</span>
                                </div>
                        </div>
                            
                            <table className='table table-bordered  splTable'>
                                <tfoot className='show-footer-above'>
                                    <tr>
                                        <th>Total</th>
                                        <th data-toggle="tooltip" data-placement="top" title={allBrandTotal}>
                                            ₹{formatAmount(allBrandTotal)}
                                        </th>
                                        <th data-toggle="tooltip" data-placement="top" title={wayBrandTotal}>
                                            ₹{formatAmount(wayBrandTotal)}
                                        </th>
                                    </tr>
                                </tfoot>
                                <thead className="sticky top-0 ">
                                    <tr>
                                        <th >Category Name</th>
                                        <th>Competitor Value</th>
                                        <th>W2N Value</th>
                                    </tr>
                                </thead>
                                {queryData?.length && !loader ? (
                                    <tbody>
                                        {queryData.map((item, index) => {
                                            return (
                                                <tr key={item.id} className="group/details hover:bg-slate-100">
                                                    <th scope='row' onClick={async () => { setName((item.category)); setView(true); await loadBrandCampaigns(item.category_id, queryDateRange, queryLang, queryAdType, queryCategory, queryLocation, queryMedia, selectedQuery) }} >{((item.category === "null") ? ("-") : (item.category))}</th>
                                                    <td 
                                                        data-toggle="tooltip" 
                                                        data-placement="top" 
                                                        title={item.competitor_value}
                                                        >
                                                        {item.competitor_value !== "Not Found"
                                                            ? `₹${formatAmount(item.competitor_value)} (${calculatePercentage(item.competitor_value, allBrandTotal)}%)`
                                                            : "Not Found"}
                                                        </td>
                                                    <td data-toggle="tooltip" data-placement="top" title={item.way2news_value}>  {item.way2news_value !== "Not Found"
                                                            ? `₹${formatAmount(item.way2news_value)} (${calculatePercentage(item.way2news_value, wayBrandTotal)}%)`
                                                            : "Not Found"}</td></tr>
                                            )
                                        })}
                                    </tbody>) : ((!queryData?.length && !loader)
                                        ? <NoDataFound colspan="8" />
                                        : <TableSkelton colspan="8" />
                                )}
                            </table>
                        </div >) : null}
                    </SlTabPanel >
                </SlTabGroup >
            </div >

            {/* <SlDrawer label="Active Brands" open={open} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} style={{ '--size': '80vw' }}>
                <table className="bg-white z-50 table table-bordered">
                    <thead>
                        <tr>
                        <th>Date</th>
                        <th>Ad Format</th>
                        <th title={summaryData?.total_count}>
                            Count ({toLakhs(summaryData?.total_count)})
                        </th>
                        <th title={summaryData?.total_spent}>
                            Revenue ({toLakhs(summaryData?.total_spent)})
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        {summaryData &&
                        Object.keys(summaryData).map((date) => {
                            if (date === "total_count" || date === "total_spent") return null;
                            const data = summaryData[date];
                            return (
                                <tr key={`${date}`}>
                                <td>{date}</td>
                                <td><div className="flex gap-1 flex-wrap"> {[...new Set(data.ad_formats || [])].map((f, i) => ( <span key={i} className="px-2 py-1 bg-gray-200 rounded text-xs"> {f} </span> ))} </div></td>
                                <td>{data.count}</td>
                                <td>{toLakhs(data.spent)}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                    </table>
                <div>
                    
                    <ul>
                        {brandsList.map((brand, index) => (
                            <li key={index}>{index + 1}  .  {brand}</li>
                        ))}
                    </ul>

                    {
                        brandsList?.length && !loader ? (
                            <div class="birdviewWrapper">
                                <ul class="birdview">
                                    {brandsList.map((item, index) => {
                                        console.log(item)
                                        return (
                                            <li>
                                                <div class="theme">
                                                    {(item?.image_url) ? (<img src={item.image_url} alt="Image" />) : (<img src={NoImage} alt="Image" />)}
                                                    <div class="blur"> {(item?.image_url) ? (<img src={item.image_url} alt="Image" />) : (<img src={NoImage} alt="Image" />)}</div>
                                                    <div class="publisher">
                                                        {item?.newspaper_name ? (
                                                            <h6 style={getColors(item?.newspaper_name)}>
                                                                {item.newspaper_name}
                                                            </h6>
                                                        ) : null}
                                                        {(item?.ad_type === "Local") ? (<h6 class="local">{item.ad_type}</h6>) : ((item?.ad_type === "National") ? (<h6 class="national">{item.ad_type}</h6>) : (<h6 class="districts">{item.ad_type}</h6>))}
                                                    </div>
                                                    <p className="location"><img src={LocationSVG} alt="location_name" title={item.location} />{getLocations(item.location)}</p>
                                                    <p class="estimation">Est Val: <strong>{item.estimated_value || 0}</strong></p>
                                                    {item.image_url ? (<Button className="previewBtn" variant="neutral"
                                                        onClick={() => { setImgSrc(item.image_url); setSee(true) }}
                                                    >
                                                        Preview
                                                    </Button>) : null}
                                                     <button onClick={()=>{
              setReportId(item.id);
              setImageUrl(item.image_url)
              setShowReport(true)
             }} className="border-[1px] !z-10 !border-red-500 bg-white text-xs font-bold text-red-500 px-2 py-1 rounded-md absolute right-2 top-2 flex gap-1 items-center hover:text-white hover:!bg-red-500"><sl-icon library="lucide" name="alert-triangle"></sl-icon><span>Report</span></button>
                                                </div>
                                                <div class="description">
                                                    {(item?.page_no) ? (<p>Page {item.page_no} : {formatDate(item.date)}</p>) : (<p>Page -  : {formatDate(item.date)}</p>)}
                                                    <h1>{item.campaign_name || "-"}</h1>
                                                    <h5>Edition : {item.edition || " "}</h5>
                                                    <h5>Ad Format : {item.ad_format || " "}</h5>
                                                    <h5>Brand name : {item.brand_name || " "}</h5>
                                                </div>                                               

                                            </li>)
                                    })}
                                </ul>
                            </div>
                        ) : !brandsList?.length && !loader ? (
                            <NoDataFound colspan="17" />
                        ) : (
                            <div class="d-flex justify-content-center">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        )
                    }
                </div>

            </SlDrawer > */}
            {open ? <PrintDataSummary open={open} handleRequestClose={handleRequestClose} handleClose={handleClose} payload={summaryPayload} getColors={getColors} /> : null}
            {/* <SlDrawer label={`Active Campaigns of ${name}`} open={view} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} style={{ '--size': '80vw' }}>
                <div>
                    {
                        campaigns?.length && !loader ? (
                            <div class="birdviewWrapper">

                                {selectedQuery === 'all_brands' || selectedQuery === 'top_20_brands' || selectedQuery === 'top_50_brands' ? 
                                <div>
                                    <h4 className='mb-1'>Summary</h4>
                                    <table className="table table-bordered max-w-[75%]">
                                    <thead>
                                        <tr>
                                            <td>Date</td>
                                            <td>Count (<b>{Object.keys(summary)?.reduce((total, date) => total = total+ summary[date].count, 0)}</b>)</td>
                                            <td>Ad Formats</td>
                                            <td title={Object.keys(summary)?.reduce((total, date) => total = total+ parseFloat(summary[date].spent || 0), 0) || 0}>Spent (<b>{formatAmount(Object.keys(summary)?.reduce((total, date) => total = total+ parseFloat(summary[date].spent || 0), 0) || 0)}</b>)</td>
                                        </tr>
                                    </thead>
                                    {Object.keys(summary)?.length ? <tbody>
                                        {Object.keys(summary)?.map((date) => {
                                            return (
                                                <tr>
                                                    <td>{formatDate(date)}</td>
                                                    <td>{summary[date].count}</td>
                                                    <td className='text-wrap'>{summary[date].ad_format.join(', ')}</td>
                                                    <td title={summary[date].spent}>{formatAmount(summary[date].spent)}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody> : <NoDataFound></NoDataFound>}
                                </table></div> : null}
                                <ul class="birdview">
                                    {campaigns.map((item, index) => {
                                        console.log(item, "heree")
                                        return (
                                            <li>
                                                <div class="theme">
                                                    {(item?.image_url) ? (<img src={item.image_url} alt="Image" />) : (<img src={NoImage} alt="Image" />)}
                                                    <div class="blur"> {(item?.image_url) ? (<img src={item.image_url} alt="Image" />) : (<img src={NoImage} alt="Image" />)}</div>
                                                    <div class="publisher">
                                                        {item?.newspaper_name ? (
                                                            <h6 style={getColors(item?.newspaper_name)}>
                                                                {item.newspaper_name}
                                                            </h6>
                                                        ) : null}
                                                        {(item?.ad_type === "Local") ? (<h6 class="local">{item.ad_type}</h6>) : ((item?.ad_type === "National") ? (<h6 class="national">{item.ad_type}</h6>) : (<h6 class="districts">{item.ad_type}</h6>))}
                                                    </div>
                                                    <p className="location"><img src={LocationSVG} alt="location_name" title={item.location} />{getLocations(item.location)}</p>
                                                    <p class="estimation">Est Val: <strong>{item.estimated_value || 0}</strong></p>
                                                    {item.image_url ? (<Button className="previewBtn" variant="neutral"
                                                        onClick={() => { setImgSrc(item.image_url); setSee(true) }}
                                                    >
                                                        Preview
                                                    </Button>) : null}
                                                     <button onClick={()=>{
              setReportId(item.id);
              setImageUrl(item.image_url)
              setShowReport(true)
             }} className="border-[1px] !z-10 !border-red-500 bg-white text-xs font-bold text-red-500 px-2 py-1 rounded-md absolute right-2 top-2 flex gap-1 items-center hover:text-white hover:!bg-red-500"><sl-icon library="lucide" name="alert-triangle"></sl-icon><span>Report</span></button>
                                                </div>
                                                <div class="description">
                                                    {(item?.page_no) ? (<p>Page {item.page_no} : {formatDate(item.date)}</p>) : (<p>Page -  : {formatDate(item.date)}</p>)}
                                                    <h1>{item.campaign_name || "-"}</h1>
                                                    <h5>Edition : {item.edition || " "}</h5>
                                                    <h5>Ad Format : {item.ad_format || " "}</h5>
                                                    <h5>Brand name : {item.brand_name || " "}</h5>


                                                </div>

                                            </li>)
                                    })}
                                </ul>
                            </div>
                        ) : !campaigns?.length && !loader ? (
                            <NoDataFound colspan="17" />
                        ) : (
                            <div class="d-flex justify-content-center">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        )
                    }
                </div>

            </SlDrawer > */}
            {view ? <PrintDataSummary title={`Summary of ${name}`} open={view} handleRequestClose={handleRequestClose} handleClose={handleClose} payload={summaryPayload} getColors={getColors}/> : null}

            <Modal className="birdview-image-preview" show={see} onHide={() => setSee(false)}>
                <Modal.Header closeButton>Image Preview
                </Modal.Header>
                <Modal.Body>
                    <img src={imgSrc} alt="" />
                </Modal.Body>
            </Modal >
                   <ReportBirdview open={showReport} setOpen={setShowReport} reportId={reportId} image_url={imageUrl}/>
            
        </div>
    )

}
export default CompetitorReports